import '../assets/styles/components/Divider.sass'

export default function Divider(){
  return (
    <div className="divider"></div>
  );
}